import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { CreateCurriculumSection } from '../create-curriculum-section';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { JobportalAddSkillButton } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-button';
import type { AddSkillSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-dialog';
import { JobportalAddSkillDialog } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-add-skill-dialog';
import { JobportalSkillCard } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-skill/jobportal-skill-card';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import type { CreateCurriculumSchema } from '@eliadmin/core/src/pages/(jobportal)/create-curriculum/page';
import { useFormContext } from 'react-hook-form';

export const CreateCurriculumStep5 = () => {
  const { t } = useTranslations();

  const form = useFormContext<CreateCurriculumSchema>();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const skills = form.watch('skills');

  const handleSkillEdit = (skill: AddSkillSchemaType) => {
    if (skill.id === undefined) return;

    const newSkills = skills?.map((e: AddSkillSchemaType) => {
      if (e.id === skill.id) {
        return skill;
      }
      return e;
    });
    form.setValue('skills', newSkills as any);
  };

  const handleSkillEditClick = (skill: AddSkillSchemaType) => {
    openDialog({
      id: JobportalAddSkillDialog.id,
      content: <JobportalAddSkillDialog onEdit={handleSkillEdit} dataToEdit={skill} />,
    });
  };

  const handleSkillDelete = (skill: AddSkillSchemaType) => {
    const newSkills = skills?.filter((e: AddSkillSchemaType) => e.id !== skill.id);
    form.setValue('skills', newSkills || []);
  };

  const handleSkillDeleteClick = (skill: AddSkillSchemaType) => {
    handleSkillDelete(skill);
  };
  return (
    <div className={cn('create-curriculum-step-wrapper flex w-full flex-col gap-4')}>
      <CreateCurriculumSection title={t('text1742')}>
        <p className="text-[#63626F]">{t('text1753')}</p>
        <div className={cn('flex flex-col gap-2', 'ea-jobportal-add-skill__cards-wrapper')}>
          {skills?.length === 0 && (
            <p className={cn('p-6 text-muted-foreground', 'text-sm')}>{t('text1019')}</p>
          )}
          {skills?.map((skill: AddSkillSchemaType, index: number) => (
            <JobportalSkillCard
              key={index}
              skill={skill}
              onSkillEditClick={() => handleSkillEditClick(skill)}
              onSkillDeleteClick={() => handleSkillDeleteClick(skill)}
            />
          ))}
        </div>
        <JobportalAddSkillButton />
      </CreateCurriculumSection>
    </div>
  );
};
